async function fetchBundleUrlsAndIntegrity(bundleUrl) {
    try {
        /**
         * Fetch the details of the bundle URL and its SRI hashes.
         */

        const response = await fetch(bundleUrl);

        if (!response.ok) {
            return console.error(`Failed to fetch bundles from ${bundleUrl}`);
        }

        const bundles = await response.json();

        if (bundles.length === 0) {
            return console.error('No bundles are being retrieved');
        }

        /**
             * Example of response data.
					const bundles = [
						{
							url: 'https://code.jquery.com/jquery-3.5.1.min.js',
							integrity:'sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0=',
						},
						.
						.
					];
            */
        /**
         *  Load the bundle URL and its SRI hashes one by one.
         */
        for (const bundle of bundles) {
            try {
                /**
                 * bundle object
                 * @type {url: string, integrity: string}
                 */
                const scriptElement = document.createElement('script');
                scriptElement.setAttribute('src', bundle.url);
                scriptElement.setAttribute('integrity', bundle.integrity);
                scriptElement.setAttribute('crossorigin', 'anonymous');
                document.body.appendChild(scriptElement);
            } catch (error) {
                console.error(`Error loading script:`, error);
            }
        }
    } catch (error) {
        console.error(`Bundles fetching error`);
        console.error(error);
    }
}

const bundleUrl = 'http://localhost:3000/fectbundle'; // Add an endpoint to fetch details of the bundle URL and integrity details
// fetchBundleUrlsAndIntegrity(bundleUrl);
